export const SCHEDULE_UPCOMING_PAYMENT_DAYS = 7;
export const UPCOMING_CHARGE_DAYS = 4;

export const MAX_SERVICE_PROVIDER_STRIPE_PAYMENT_CENT_AMOUNT = 10_000_00; /* ¢ */
export const MIN_SERVICE_PROVIDER_STRIPE_PAYMENT_CENT_AMOUNT = 50; /* ¢ */
